<template>
  <div class="form-group" :class="colStyle">
    <Field
      v-model="getValue"
      v-slot="{ errors, field }" 
      :name="name"
      :rules="rules">
      <label :for="name">{{label}} <span v-if="isRequired" class="text-danger">*</span></label>
      <select 
        :name="name" 
        v-bind="field" 
        type="select"
        class="form-control"
        :disabled="disabled"
        :class="{'is-invalid': errors[0]}" 
        @change="$emit('update:modelValue', $event.target.value)"
        >
        <template v-for="(row, index) in options" :key="index">
          <option :value="row[valueKey]">
            {{row[labelKey]}}
          </option>
        </template>
      </select>
      <InvalidFeedback :name="getErrorName" :errors="errors"/>
    </Field>
  </div>
</template>

<script>
import { useForm, Form as VeeForm, Field, ErrorMessage } from 'vee-validate';
import InvalidFeedback from "@/src/components/shared/InvalidFeedback.vue";
import { formMixin } from "@/src/mixins/formMixin.js";

export default {
  components: {
    InvalidFeedback,
    VeeForm,
    Field,
    ErrorMessage,
  },
  props: {
    colStyle: { default: 'form-group-standard-6-column-medium-up' },
    options: { default: [] },
    labelKey: { default: 'value' },
    valueKey: { default: 'code' },
  },
  emits: ['update:modelValue'],
  mixins: [ formMixin ],
}
</script>
